import SingleDatePicker from './SingleDatePicker.component';
export default SingleDatePicker;